<template>
    <div id="imageCarousel" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner">
            <div class="carousel-item active">
                <div class="d-flex gap-3">
                    <img src="@/assets/images/home/advocacypillar/img1.png" class="d-block w-100">
                    <img src="@/assets/images/home/advocacypillar/img1.png" class="d-block w-100">
                    <img src="@/assets/images/home/advocacypillar/img1.png" class="d-block w-100">
                    <img src="@/assets/images/home/advocacypillar/img1.png" class="d-block w-100">
                </div>
            </div>

            <div class="carousel-item">
                <div class="d-flex gap-3">
                    <img src="@/assets/images/home/advocacypillar/img1.png" class="d-block w-100">
                    <img src="@/assets/images/home/advocacypillar/img1.png" class="d-block w-100">
                    <img src="@/assets/images/home/advocacypillar/img1.png" class="d-block w-100">
                    <img src="@/assets/images/home/advocacypillar/img1.png" class="d-block w-100">
                </div>
            </div>
        </div>
    </div>
    <DotsPagination/>
</template>

<style scoped>
#imageCarousel {
    margin-top: 50px;
}

.carousel-inner .carousel-item {
    display: flex;
    justify-content: center;
}

.carousel-inner .carousel-item .d-flex {
    display: flex;
    width: 100%;
}

.carousel-inner .carousel-item img {
    flex: 1;
    height: 425px;
    object-fit: cover;
    border-radius: 20px;
}


</style> 

<script>

import DotsPagination from '@/components/Pagination/DotsPagination.vue';

export default {
    components: { 
        DotsPagination
    }
}
</script>